import {
  ATTRS_ANALYTICS_FUNNEL_LOCALE,
  ATTRS_ANALYTICS_FUNNEL_NAME,
} from 'core/common/observability/entities';
import { ObservabilitySystem } from 'core/common/observability/interfaces';
import { ErrorMonitoring } from 'core/common/services/errorMonitoring';
import { FunnelSettingsServiceInterface } from 'core/common/services/funnel-settings/interfaces';
import { TaboolaService } from '../../interfaces';
import { TaboolaServiceWithMonitoring } from './TaboolaServiceWithMonitoring';

export class TaboolaServiceBuilder {
  constructor(private taboolaService: TaboolaService) {}

  addMonitoring(
    observabilitySystem: ObservabilitySystem,
    errorMonitoringService: ErrorMonitoring,
    funnelSettingsService: FunnelSettingsServiceInterface,
  ): this {
    const provideAdditionalObservabilityAttributes = () => {
      return {
        [ATTRS_ANALYTICS_FUNNEL_NAME]: funnelSettingsService.getFunnelName(),
        [ATTRS_ANALYTICS_FUNNEL_LOCALE]: funnelSettingsService.getFunnelLocale(),
      };
    };

    this.taboolaService = new TaboolaServiceWithMonitoring(
      this.taboolaService,
      observabilitySystem,
      errorMonitoringService,
      provideAdditionalObservabilityAttributes,
    );

    return this;
  }

  getResult(): TaboolaService {
    return this.taboolaService;
  }
}
